<template>
  <v-container fluid tag="section">

    <v-row>
      <z-fund-account-select multiple="false" v-model="account" :label="$i18n.t('Fund Account Select')" />
    </v-row>
    <v-row>{{ account }}</v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Demo extends Vue {
  lat = 28.508;
  account = null;
  lon = 77.587;
  zoom = 8;
  lines = [
    {
      line:
        "AAA1555196266===_hwlDeuiuM?auKahH_v@eoChsAcyANcAmyA??oyARwAwyABKwyA??izAVgB_{APqAi{A??k{AT}As{A??s{AbAqH}|A@I}|A??g}APaAs}A??s}ABKs}ADYg~A",
      strokeColor: "red",
      editable: false,
    },
  ];
  showSearch = true;
  showCentreMarker = false;
  markers = [
    {
      position: { lat: 22.123, lng: 74.13232 },
      addressLine: "JMD Megapolis",
      // icon: "/url",
      infoText: "This is me...marker 1",
    },
    {
      position: { lat: 22.123, lng: 78.13232 },
      addressLine: "JMD Megapolis",
      // icon: "/url",
      infoText: "This is me...but not marker 1",
    },
  ];

  zoom_changed(zoom) {
    // console.log("zoom", zoom);
  }
  async mounted() {
    console.log("mounted")
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}

.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
</style>
